import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const insuranceProductApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'insuranceProductApi',
  tagTypes: [
    'InsuranceCategoryList',
    'InsuranceCategoryCreate',
    'InsuranceCategoryUpdate',
    'InsuranceCategoryDelete'
  ],
  endpoints: () => ({})
})

export default insuranceProductApi
